import * as React from "react"
import AppBar from "@mui/material/AppBar"
import Box from "@mui/material/Box"
import Toolbar from "@mui/material/Toolbar"
import IconButton from "@mui/material/IconButton"
import Typography from "@mui/material/Typography"
import Menu from "@mui/material/Menu"
import MenuIcon from "@mui/icons-material/Menu"
import Container from "@mui/material/Container"
import Avatar from "@mui/material/Avatar"
import Tooltip from "@mui/material/Tooltip"
import MenuItem from "@mui/material/MenuItem"
import Stack from "@mui/material/Stack"

import { Link } from "react-router-dom"
import { useUserAuth } from "../firebase/UserAuthContext"

const pages = ["inicio", "entrenamientos", "torneos", "info", "contacta"]
const settings = ["profile"]
const ResponsiveAppBar = (props) => {
	const [anchorElNav, setAnchorElNav] = React.useState(null)
	const [anchorElUser, setAnchorElUser] = React.useState(null)

	const handleOpenNavMenu = (event) => {
		setAnchorElNav(event.currentTarget)
	}
	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget)
	}

	const handleCloseNavMenu = (event) => {
		//console.log(event.currentTarget)
		setAnchorElNav(null)
	}

	const handleCloseUserMenu = () => {
		setAnchorElUser(null)
	}
	const { user } = useUserAuth()

	const pageTitle = props.title
	return (
		<AppBar position="static">
			<Container maxWidth="xl">
				<Toolbar disableGutters>
					<Stack
						spacing={2}
						direction="row"
						sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
					>
						<img src="./favicon-32x32.png" alt="bug" />
						<Typography variant="h6" noWrap component="div">
							{pageTitle}
						</Typography>
					</Stack>

					<Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="menu-appbar"
							aria-haspopup="true"
							onClick={handleOpenNavMenu}
							color="inherit"
						>
							<MenuIcon />
						</IconButton>
						<Menu
							id="menu-appbar"
							anchorEl={anchorElNav}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "left",
							}}
							keepMounted
							transformOrigin={{
								vertical: "top",
								horizontal: "left",
							}}
							open={Boolean(anchorElNav)}
							onClose={handleCloseNavMenu}
							sx={{
								display: { xs: "block", md: "none" },
							}}
						>
							{pages.map((page, index) => (
								<MenuItem
									key={index}
									component={Link}
									to={page}
									onClick={handleCloseNavMenu}
								>
									<Typography variant="h6" noWrap component="div">
										{page.toUpperCase()}
									</Typography>
								</MenuItem>
							))}
						</Menu>
					</Box>
					<Stack
						spacing={2}
						direction="row"
						sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
					>
						<img src="./favicon-32x32.png" alt="bug" />
						<Typography variant="h6" noWrap component="div">
							{pageTitle}
						</Typography>
					</Stack>

					<Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
						{pages.map((page) => (
							<MenuItem
								key={page}
								component={Link}
								to={page}
								onClick={handleCloseNavMenu}
								sx={{ my: 2, color: "white", display: "block" }}
							>
								<Typography variant="h6" noWrap component="div">
									{page.toUpperCase()}
								</Typography>
							</MenuItem>
						))}
					</Box>

					<Box sx={{ flexGrow: 0 }}>
						<Stack spacing={2} direction="row">
							{user && (
								<Typography
									variant="h6"
									noWrap
									component="div"
									mt={0.5}
									sx={{ mr: 2, display: { xs: "none", md: "flex" } }}
								>
									{user.displayName}
								</Typography>
							)}

							<Tooltip title="Open settings">
								<IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
									{" "}
									{!user && (
										<Avatar alt="No user" src="/static/images/avatar/2.jpg" />
									)}
									{user && (
										<Avatar alt={user?.displayName} src={user?.photoURL} />
									)}
								</IconButton>
							</Tooltip>
						</Stack>

						<Menu
							sx={{ mt: "45px" }}
							id="menu-appbar"
							anchorEl={anchorElUser}
							anchorOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
							keepMounted
							transformOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
							open={Boolean(anchorElUser)}
							onClose={handleCloseUserMenu}
						>
							{user ? (
								settings.map((setting) => (
									<MenuItem
										key={setting}
										component={Link}
										onClick={handleCloseUserMenu}
										to="signin"
									>
										<Typography textAlign="center">{setting}</Typography>
									</MenuItem>
								))
							) : (
								<MenuItem
									key="SignIn"
									component={Link}
									onClick={handleCloseUserMenu}
									to="signin"
								>
									<Typography textAlign="center">Sign In</Typography>
								</MenuItem>
							)}
						</Menu>
					</Box>
				</Toolbar>
			</Container>
		</AppBar>
	)
}
export default ResponsiveAppBar
